const pageInitialComponentsMap = {
  loading: 'loading',
  login: 'login',
  no_permissions: 'no_permissions',
  page: 'page',
}

export default pageInitialComponentsMap
